module.exports = __webpack_public_path__ + "static/media/ppt.9ec3e018.svg";